import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05b60c90"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "business-box"
};
const _hoisted_2 = ["src"];
import { onMounted, ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MyBusiness',
  setup(__props) {
    const businessList = ref([]);
    const initBusiness = () => {
      businessList.value = [{
        url: "http://ocr.nbdj.cc/test/business-technology.png",
        name: '牛站介绍',
        details: '牛站介绍，包含视频教学、项目源码、售后服务的介绍',
        // href: '/business/technology'
        href: 'article/detail/22'
      }, {
        url: "http://ocr.nbdj.cc/test/business-gradproject.png",
        name: '项目源码',
        details: '提供2000多计算机毕业项目源码，包括微信小程序、ssm、springboot等',
        href: '/business/project'
      }, {
        url: "http://ocr.nbdj.cc/test/business-work.png",
        name: '视频教学',
        details: '提供主流的Java后端开发、前后端实战项目开发的视频教学',
        href: '/business/video'
      }, {
        url: "http://ocr.nbdj.cc/test/business-interview.png",
        name: '面试题解',
        details: '提供史上最全的面试题解，包括前端、后端、网络安全等',
        href: '/business/interview'
      }
      // {
      //   url: "http://ocr.nbdj.cc/test/business-study-material.png",
      //   name: '学习资料',
      //   details: '精选项目、考证等优质学习资料，内容专业',
      //   href: '/business/studyMaterial'
      // }
      ];
    };
    onMounted(() => {
      //初始化业务介绍
      initBusiness();
    });
    return (_ctx, _cache) => {
      const _component_a_card_meta = _resolveComponent("a-card-meta");
      const _component_a_card = _resolveComponent("a-card");
      const _component_RouterLink = _resolveComponent("RouterLink");
      const _component_a_list_item = _resolveComponent("a-list-item");
      const _component_a_list = _resolveComponent("a-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_list, {
        grid: {
          gutter: 60,
          xs: 1,
          sm: 2,
          md: 2,
          lg: 4,
          xl: 4,
          xxl: 4
        },
        "item-layout": "horizontal",
        "data-source": businessList.value
      }, {
        renderItem: _withCtx(({
          item
        }) => [_createVNode(_component_a_list_item, {
          style: {
            "display": "flex",
            "justify-content": "center",
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_RouterLink, {
            to: item.href
          }, {
            default: _withCtx(() => [_createVNode(_component_a_card, {
              hoverable: "",
              style: {
                "width": "250px",
                "height": "250px",
                "text-align": "center",
                "padding": "10px"
              }
            }, {
              cover: _withCtx(() => [_createElementVNode("img", {
                style: {
                  "height": "100px",
                  "width": "100px",
                  "margin": "0 auto"
                },
                alt: "",
                src: item.url
              }, null, 8, _hoisted_2)]),
              default: _withCtx(() => [_createVNode(_component_a_card_meta, {
                title: item.name
              }, {
                description: _withCtx(() => [_createTextVNode(_toDisplayString(item.details), 1)]),
                _: 2
              }, 1032, ["title"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["to"])]),
          _: 2
        }, 1024)]),
        _: 1
      }, 8, ["data-source"])]);
    };
  }
});